// extracted by mini-css-extract-plugin
export var brand = "_av-9";
export var compact = "_av-6";
export var extraSmall = "_av-7";
export var icon = "_av-0";
export var large = "_av-4";
export var light = "_av-1";
export var medium = "_av-5";
export var outline = "_av-b";
export var primaryDark = "_av-a";
export var primaryLight = "_av-8";
export var primaryModern = "_av-c";
export var success = "_av-2";
export var successSolid = "_av-3";